import { TranRecordModel } from "./tran-record.model";

export class UpdatePStatusModel {
    Trans: TranRecordModel
    intStatus: boolean

    constructor(
        Trans: TranRecordModel,
        intStatus: boolean
    ) {
        this.Trans = Trans
        this.intStatus = intStatus
    }
}